(function(){
  document.querySelectorAll('[data-stro-pdp]').forEach(function(root){
  var d = JSON.parse(root.querySelector('[data-stro-pdata]').textContent);
  var base = (d.root || '/').replace(/\/$/, '');
  var $ = function(s){ return root.querySelector(s); };
  var $$ = function(s){ return Array.prototype.slice.call(root.querySelectorAll(s)); };
  function money(c){
    var a = c / 100, s = (c % 100 === 0) ? String(Math.round(a)) : a.toFixed(2);
    s = s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (d.fmt || '\u00a3{{amount}}').replace(/\{\{\s*\w+\s*\}\}/, s);
  }
  var state = { v: Math.max(0, d.variants.findIndex(function(v){ return v.id === d.selected; })), img: 0, qty: 1, tier: 1 };
  state.opts = (d.variants[state.v] && d.variants[state.v].opts) ? d.variants[state.v].opts.slice() : [];

  var main = $('[data-g-main]'), count = $('[data-g-count]'), thumbs = $$('[data-g-thumb]');
  function showImg(i){
    if (!d.media.length || !main) return;
    state.img = (i + d.media.length) % d.media.length;
    main.src = d.media[state.img];
    if (count) count.textContent = (state.img + 1) + ' / ' + d.media.length;
    thumbs.forEach(function(t, k){ t.setAttribute('aria-current', k === state.img ? 'true' : 'false'); });
    var t = thumbs[state.img]; if (t && t.parentNode) { var p = t.parentNode; p.scrollTo({ left: t.offsetLeft - p.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' }); }
  }
  var prev = $('[data-g-prev]'), next = $('[data-g-next]');
  if (prev) prev.addEventListener('click', function(){ showImg(state.img - 1); });
  if (next) next.addEventListener('click', function(){ showImg(state.img + 1); });
  thumbs.forEach(function(t, k){ t.addEventListener('click', function(){ showImg(k); }); });

  var vbtns = $$('[data-v]'), obtns = $$('[data-opt-i]');
  function tierOff(){ var t = d.tiers[state.tier - 1]; return d.live && d.showTiers && t ? t.off : 0; }
  function optAvailable(i, val){
    return d.variants.some(function(v){ if (!v.opts || !v.avail) return false; for (var k = 0; k < v.opts.length; k++) { if (k === i) { if (v.opts[k] !== val) return false; } else if (k < i && v.opts[k] !== state.opts[k]) return false; } return true; });
  }
  function paint(){
    var v = d.variants[state.v]; if (!v) return;
    $$('[data-p-price]').forEach(function(el){ el.textContent = money(v.price); });
    var was = $('[data-p-was]'); if (was) was.textContent = v.was > v.price ? money(v.was) : '';
    $$('[data-p-label]').forEach(function(el){ el.textContent = v.label; });
    var fin = $('[data-p-finish]'); if (fin) fin.textContent = v.label.toLowerCase();
    vbtns.forEach(function(b){ b.setAttribute('aria-pressed', Number(b.getAttribute('data-v')) === state.v ? 'true' : 'false'); });
    obtns.forEach(function(b){
      var i = Number(b.getAttribute('data-opt-i')), val = b.getAttribute('data-opt-v');
      b.setAttribute('aria-pressed', state.opts[i] === val ? 'true' : 'false');
      b.classList.toggle('is-out', !optAvailable(i, val));
    });
    $$('[data-opt-label]').forEach(function(el){ el.textContent = state.opts[Number(el.getAttribute('data-opt-label'))] || ''; });
    $$('[data-tier]').forEach(function(b){
      var n = Number(b.getAttribute('data-tier')), t = d.tiers[n - 1];
      b.setAttribute('aria-pressed', n === state.tier ? 'true' : 'false');
      var each = b.querySelector('[data-tier-each]');
      if (each) each.textContent = money(Math.round(v.price * (1 - (d.live ? t.off : 0))));
    });
    var q = $('[data-qty]'); if (q) q.textContent = state.qty;
    var total = Math.round(v.price * state.qty * (1 - tierOff()));
    var add = $('[data-p-add]');
    add.disabled = !v.avail;
    add.textContent = v.avail ? 'Add to bag \u00b7 ' + money(total) : 'Sold out';
    var sAdd = $('[data-s-add]'); if (sAdd) { sAdd.disabled = !v.avail; sAdd.textContent = v.avail ? 'Add to bag' : 'Sold out'; }
    var low = $('[data-p-low]'); if (low) low.style.display = v.avail ? '' : 'none';
    if (window.history && history.replaceState && d.variants.length > 1) {
      var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString());
    }
  }
  function selectVariant(i){ state.v = i; var v = d.variants[i]; if (v.opts) state.opts = v.opts.slice(); if (v.media >= 0) showImg(v.media); paint(); }
  vbtns.forEach(function(b){ b.addEventListener('click', function(){ selectVariant(Number(b.getAttribute('data-v'))); }); });
  obtns.forEach(function(b){
    b.addEventListener('click', function(){
      var i = Number(b.getAttribute('data-opt-i'));
      state.opts[i] = b.getAttribute('data-opt-v');
      var match = -1, fallback = -1;
      d.variants.forEach(function(v, k){
        if (!v.opts) return;
        var ok = v.opts.every(function(o, j){ return o === state.opts[j]; });
        if (ok && match < 0) match = k;
        if (fallback < 0 && v.opts[i] === state.opts[i] && v.avail) fallback = k;
      });
      if (match < 0) match = fallback;
      if (match >= 0) selectVariant(match); else paint();
    });
  });

  $$('[data-tier]').forEach(function(b){ b.addEventListener('click', function(){ state.tier = Number(b.getAttribute('data-tier')); state.qty = state.tier; paint(); }); });
  function setQty(q){ state.qty = Math.max(1, Math.min(10, q)); state.tier = Math.min(3, state.qty); paint(); }
  var dec = $('[data-qty-dec]'), inc = $('[data-qty-inc]');
  if (dec) dec.addEventListener('click', function(){ setQty(state.qty - 1); });
  if (inc) inc.addEventListener('click', function(){ setQty(state.qty + 1); });

  var toast = $('[data-stro-toast]'), tt;
  function showToast(msg, err){
    toast.querySelector('b').textContent = err ? 'Heads up' : 'Added to bag';
    toast.querySelector('[data-toast-name]').textContent = msg;
    toast.classList.add('is-on'); clearTimeout(tt); tt = setTimeout(function(){ toast.classList.remove('is-on'); }, 2600);
  }
  function add(id, qty, name, btn){
    if (btn) btn.disabled = true;
    fetch(base + '/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }] }) })
      .then(function(r){ if (!r.ok) return r.json().then(function(e){ throw e; }); return r.json(); })
      .then(function(){ return fetch(base + '/cart.js').then(function(r){ return r.json(); }); })
      .then(function(c){ document.querySelectorAll('[data-stro-count]').forEach(function(el){ el.textContent = c.item_count; }); showToast(name); document.dispatchEvent(new CustomEvent('cart:refresh')); })
      .catch(function(e){ showToast((e && e.description) || 'Sorry, that option is unavailable right now.', true); })
      .finally(function(){ if (btn) btn.disabled = false; paint(); });
  }
  function addCurrent(btn){ var v = d.variants[state.v]; add(v.id, state.qty, d.title + (d.variants.length > 1 ? ' \u2014 ' + v.label : '') + (state.qty > 1 ? ' \u00d7 ' + state.qty : ''), btn); }
  $('[data-p-add]').addEventListener('click', function(e){ addCurrent(e.currentTarget); });
  var sAdd = $('[data-s-add]'); if (sAdd) sAdd.addEventListener('click', function(e){ addCurrent(e.currentTarget); });
  root.addEventListener('click', function(e){ var b = e.target.closest('[data-stro-add]'); if (b) add(b.getAttribute('data-stro-add'), 1, b.getAttribute('data-stro-name'), b); });

  var sticky = $('[data-stro-sticky]'), mainBtn = $('[data-p-add]');
  if (sticky && 'IntersectionObserver' in window) {
    new IntersectionObserver(function(en){ var e = en[0]; sticky.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0); }).observe(mainBtn);
  }

  var track = $('[data-rev-track]');
  $$('[data-rev]').forEach(function(b){ b.addEventListener('click', function(){ track.scrollBy({ left: Number(b.getAttribute('data-rev')) * track.clientWidth * 0.8, behavior: 'smooth' }); }); });

  showImg(Math.max(0, (d.variants[state.v] || {}).media || 0));
  paint();
  });
})();
